import SearchCriteriaGroupItem from './search-criteria-group-item-component';
import SearchCriteriaGroupItemService from './search-criteria-group-item-service';

const MODULE_NAME = 'app.common.search-criteria-group-item';
const module = angular.module(MODULE_NAME, [])
    .directive(SearchCriteriaGroupItem.DIRECTIVE_NAME, SearchCriteriaGroupItem)
    .service('searchCriteriaGroupItemService', SearchCriteriaGroupItemService);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/modules/common/search-criteria-group-item/search-criteria-group-item-module.js